import { NgModule, SkipSelf, Optional } from "@angular/core";
import { AuthService, DateService, AuthGuard } from "./services";
import { RecipientService } from "./services/recipient.service";
import { FirebaseService } from "./firebase/firebase.service";

@NgModule({
  imports: [],
  providers: [
    FirebaseService,
    AuthService,
    DateService,
    RecipientService,
    AuthGuard
  ],
  entryComponents: [],
  declarations: [],
  exports: []
})
export class CoreModule {}
